import classnames from 'classnames';
import React, { FC } from 'react';
import { MainSource } from '../../../../constants/Source';
import { useBoardThumbnail } from '../../../../utils/hooks/useBoardThumbnail';
import { ResizedImage } from '../../ResizedImage';
import styles from './BoardThumbnail.scss';
import { IBoardThumbnail } from './BoardThumbnail.types';

export const BoardThumbnail: FC<IBoardThumbnail> = ({
  board,
  className,
  imageClassName,
  dataHook = 'board-thumbnail',
  width,
  height,
}) => {
  const { thumbnailUrl, isSystemThumbnailUrl, dataThumbnailUrl } = useBoardThumbnail(board);

  return (
    <div className={className} data-hook={dataHook}>
      {isSystemThumbnailUrl ? (
        <img
          src={thumbnailUrl}
          className={classnames(styles.systemThumbnail, imageClassName)}
          data-hook="system-thumbnail"
          data-thumbnail-url={dataThumbnailUrl}
        />
      ) : (
        <ResizedImage
          dataHook="custom-thumbnail"
          source={MainSource.Boards}
          className={imageClassName}
          src={thumbnailUrl}
          width={width}
          height={height}
        />
      )}
    </div>
  );
};
